import { Deal } from "../../models/shared/Deal";
import { AuditDealRecordStepChange } from "../../models/shared/DealAuditRecord";
import { DealStep } from "../../models/shared/DealStep";

export interface StepRecord {
    secondsTotal: number;
    seconds: number;
    minutes: number;
    hours: number;
    days: number;
}

export const calculateTimePerStep = (deal: Deal, allSteps: DealStep[]) => {
    const result: Record<string, StepRecord> = {};

    for (const step of allSteps) {
        result[step.id] = {
            secondsTotal: 0,
            seconds: 0,
            minutes: 0,
            hours: 0,
            days: 0,
        };
    }

    let lastTime = deal.createdAt;
    let lastStepId = '';

    const records = deal.auditRecords || [];
    const stepChangeRecords = records.filter(record => record.type === 'stepChange') as AuditDealRecordStepChange[];

    for (const record of stepChangeRecords) {
        const secondsElapsed = (record.createdAt.getTime() - lastTime.getTime()) / 1000;
        if (secondsElapsed >= 1 && lastStepId && result[lastStepId]) {
            result[lastStepId].secondsTotal += secondsElapsed;
        }
        lastTime = record.createdAt;
        lastStepId = record.extras.newStepId;
    }
    if (lastStepId && result[lastStepId]) {
        const secondsElapsed = (Date.now() - lastTime.getTime()) / 1000;
        result[lastStepId].secondsTotal += secondsElapsed;
    }

    for (const step of allSteps) {
        const stepRecord = result[step.id];
        stepRecord.seconds = Math.round(stepRecord.secondsTotal % 60);
        stepRecord.minutes = Math.round(stepRecord.secondsTotal / 60) % 60;
        stepRecord.hours = Math.round(stepRecord.secondsTotal / 60 / 60) % 24;
        stepRecord.days = Math.round(stepRecord.secondsTotal / 60 / 60 / 24);
    }
    return result;
}
